<template>
    <div class="catalogPageWrapper">
        <!-- <cardCarousel @openCartSidebar="$emit('openCartSidebar')" v-if="listingsDataRaw.length > 0" :listingsData="listingsDataRaw"/> -->
        <div class="switcher">
            <languageSwitcher />
        </div>
        <div class="header">
            <div v-if="!searchWord">
                <h2 style="margin: 0;">{{$t('catalogPage.title')}}</h2>
                <p>{{$t('catalogPage.text')}}</p>
            </div>
            <div v-else>
                <h2 style="margin: 0; margin-bottom: 5px;">{{$t('catalogPage.searchText')}}: "{{ searchWord }}"</h2>
                <Button severity="contrast" icon="pi pi-times" :label="$t('buttons.resetSearch')" @click="$emit('resetSearch')" outlined text />
            </div>
            <div class="mobileBtns">
                <Select class="sortSelect" @update:modelValue="updateSortMethod" v-model="sortMethod" :options="[{name: $t('buttons.sortDESC'), code: 'DESC'}, {name: $t('buttons.sortASC'), code: 'ASC'}]" optionLabel="name" :placeholder="$t('buttons.sortASC')" />
                <Button 
                    class="categoriesBtn"
                    :label="$t('buttons.categories', currentLang)" 
                    style="color: white; background: steelblue; border: 1px solid steelblue; margin-top: 10px;" 
                    @click="$emit('openCategoriesDrawer')" 
                    icon="pi pi-list"  
                />
            </div>
        </div>
        <div class="products" v-if="isVisible">
            <productCard 
                class="productCardComponent"
                v-for="(element, index) in listingData" :key="index"
                @openCartSidebar="$emit('openCartSidebar')"
                @logout="$emit('logout')"
                :listingData="element"
                :index="5 + index"
                :waitTime="cardLoadingTime"
                :currentLang="currentLang"
            />
        </div>
        <h5 v-if="listingData.length == 0" style="font-size: 60px; color: silver">{{$t('catalogPage.noProductsErr')}}</h5>
    </div>
</template>
  
<script>
import languageSwitcher from '@/components/languageSwitcher.vue';
import productCard from '../components/shopLanding/productCard-small.vue'
import Select from 'primevue/select';
import Button from 'primevue/button';

export default {
    name: 'catalogPage',
    components: {
        languageSwitcher,
        productCard,
        Select,
        Button
    },
    watch: {
        listingData() {
            this.isVisible = false
            this.isVisible = true
        },
    }, 
    props: {
        idShop: {},

        shopData: {},
        shopPageUrl: {},

        feedbacksData: {},
        feedbackStatsData: {},

        listingData: {},
        listingsDataRaw: {},
        cardLoadingTime: {},
        counter: {},

        shippingProfileData: {},
        allCategories: [],      
        searchWord: null,
        currentLang: {default: "et"}
    },
    data() {
        return {
            isVisible: true,
            sortMethod: null,
        };
    },
    // computed: {
    //     currentLang() {
    //         return this.$route.params.lang || 'et';
    //     },
    // },
    methods: {
        categoryChange(idListingTag) {
            this.$emit('getShopListings', false, false, false, idListingTag)
        },

        updateSortMethod(method) {
            this.$emit('updateSortMethod', method.code)
        }
    },
    created() {
      // Lifecycle hook - called after the instance is created

    },
    mounted() {
      // Lifecycle hook - called after the component is mounted to the DOM
    
    },
    updated() {
      // Lifecycle hook - called after a data change causes the DOM to re-render
    
    },
    
  };
</script>
  
<style scoped>
.products {
    margin-top: 20px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    padding-left: 0px;
    row-gap: 30px;
    -webkit-column-gap: 27px;
       -moz-column-gap: 27px;
            column-gap: 27px;
}
.header {
    position: relative;
    margin-top: 20px;
    
}
.sortSelect {
    position: absolute;
    top: 15px;
    right: 0;
    border: 1px solid rgb(235,235,235);
}
.switcher {
    margin-left: auto;
    width: fit-content;
    margin-bottom: -10px;
}
.productCardComponent {
}
.categoriesMenu {
    position: sticky;
    top: 0;
}
.catalogPageWrapper {
    width: 1375px;
    margin: 0 auto;
    padding-left: 75px;
    padding-bottom: 200px;
}
.catalogPageWrapper h2 {
    font-family: 'Satoshi-Bold';
    color:  #22262A;
}
.catalogPageWrapper p {
    font-family: 'Satoshi-Medium';
    color:  #909ba7;
    margin: 0;
}
.categoriesBtn {
    display: none;
}
@media(max-width: 1730px) {
    .catalogPageWrapper {
        width: 100%;
        padding-left: 30px;
        padding-right: 20px;
        margin-left: 0;
    }
}
@media(max-width: 950px) {
    .sortSelect {
        position: relative;
        top: 10px;
        right: 0;
        border: 1px solid rgb(235,235,235);
    }
}
@media(max-width: 890px) {
    .sortSelect {
        top: 0px;
        margin-right: 10px;
    }
    .categoriesBtn {
        display:inline-flex
    }
    .catalogPageWrapper {
        padding-left: 20px;
    }
}
@media(max-width: 675px) {
    .header {
        margin-top: 0;
    }
    .switcher {
        position: absolute;
        bottom: 60px;
    }
    .catalogPageWrapper {position: relative;}
}
@media (max-width: 430px) {
    .mobileBtns {
        display: flex;
    }
    .sortSelect {
        position: relative;
        margin-top: 10px;
        height: 40px;
        width: 100%;
        border: 1px solid rgb(235,235,235);
    }
    .categoriesBtn {
        width: 220px;
    }
}
</style>